import { useCurrentUserRole } from '@app/hooks/workspace';

export default function useIsAdminMember() {
  const role = useCurrentUserRole();
  return role?.type === 'ADMIN';
}
